'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/math-intrinsics/round.js
// module id = ../../../../math-intrinsics/round.js
// module chunks = 5